import { render, staticRenderFns } from "./FormulasByResourceDialog.vue?vue&type=template&id=105ee6fc"
import script from "./FormulasByResourceDialog.vue?vue&type=script&lang=js"
export * from "./FormulasByResourceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports